window.UNISOURCE_DESIGN_CATALOG_VERSION = "v2-proxy-api-fallback";
/* =========================================================
   DESIGN CATALOG
   INTERNAL REFERENCE TOOL
   CLIENT-SIDE PAGINATION + TRANSPARENT ARTWORK PRIORITY
========================================================= */

(function () {
  "use strict";

  var CONFIG = window.UNISOURCE_DESIGN_CATALOG || {};

  var API_BASE =
    CONFIG.apiBaseUrl ||
    CONFIG.apiBase ||
    "https://shopify-inksoft-poc-node.azurewebsites.net/api/poc/design-inspiration";

  var PAGE_SIZE = Math.max(1, Number(CONFIG.pageSize) || 24);

  var els = {
    root: document.querySelector("[data-design-catalog-root]"),
    status: document.getElementById("dc-status"),
    search: document.getElementById("dc-search"),
    segment: document.getElementById("dc-segment"),
    productGroup: document.getElementById("dc-product-group"),
    collection: document.getElementById("dc-collection"),
    summary: document.getElementById("dc-summary"),
    grid: document.getElementById("dc-grid")
  };

  var allDesigns = [];
  var currentPage = getInitialPage();

  function getInitialPage() {
    var params = new URLSearchParams(window.location.search);
    var value = Number(params.get("page"));

    if (Number.isFinite(value) && value >= 1) {
      return Math.floor(value);
    }

    return 1;
  }

  function setStatus(message, type) {
    if (!els.status) return;

    els.status.textContent = message;
    els.status.className = "dc-status dc-status--" + (type || "info");
  }

  async function fetchJson(url) {
    var response = await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json"
      },
      cache: "no-store"
    });

    if (!response.ok) {
      throw new Error("HTTP " + response.status + ": " + url);
    }

    return response.json();
  }

  function escapeHtml(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function normalizeImage(url) {
    if (!url) return "";

    var raw = String(url).trim();

    if (!raw) return "";

    if (/^https?:\/\//i.test(raw)) {
      return raw;
    }

    if (raw.indexOf("/Unisource_Apparel/") === 0) {
      return "https://shop.unisourceapparel.com" + raw;
    }

    if (raw.indexOf("/images/") === 0) {
      return "https://shop.unisourceapparel.com/Unisource_Apparel" + raw;
    }

    if (raw.indexOf("Unisource_Apparel/") === 0) {
      return "https://shop.unisourceapparel.com/" + raw;
    }

    return "https://shop.unisourceapparel.com/" + raw.replace(/^\/+/, "");
  }

  function extractDesignId(design) {
    if (design.inksoftDesignId) {
      return String(design.inksoftDesignId);
    }

    var firstCanvas =
      Array.isArray(design.canvases) && design.canvases.length
        ? design.canvases[0]
        : null;

    var sources = [
      design.id,
      design.slug,
      design.thumbnailUrl,
      design.previewImageUrl,
      design.imageUrl,
      firstCanvas ? firstCanvas.thumbnailUrl : "",
      firstCanvas ? firstCanvas.imageUrl : "",
      firstCanvas ? firstCanvas.svgUrl : ""
    ];

    var patterns = [
      /DI-(\d+)/i,
      /designs\/(\d+)\./i,
      /2959-(\d+)/i,
      /-(\d{6,})$/i
    ];

    for (var i = 0; i < sources.length; i += 1) {
      var value = String(sources[i] || "");

      for (var p = 0; p < patterns.length; p += 1) {
        var match = value.match(patterns[p]);

        if (match && match[1]) {
          return match[1];
        }
      }
    }

    return "";
  }

  function getFirstCanvas(design) {
    if (Array.isArray(design.canvases) && design.canvases.length) {
      return design.canvases[0];
    }

    return null;
  }

  function getBestImage(design) {
    var firstCanvas = getFirstCanvas(design);

    var transparentSvg = normalizeImage(
      firstCanvas ? firstCanvas.svgUrl : ""
    );

    if (transparentSvg) {
      return transparentSvg;
    }

    var transparentCanvasPng = normalizeImage(
      firstCanvas ? firstCanvas.imageUrl : ""
    );

    if (transparentCanvasPng) {
      return transparentCanvasPng;
    }

    var previewImage = normalizeImage(design.previewImageUrl);

    if (previewImage) {
      return previewImage;
    }

    var designId = extractDesignId(design);

    if (designId) {
      return (
        "https://cdn.inksoft.com/images/publishers/2959/designs/" +
        designId +
        ".front.480.png"
      );
    }

    return (
      normalizeImage(design.thumbnailUrl) ||
      normalizeImage(design.imageUrl)
    );
  }

  function getFallbackImages(design) {
    var firstCanvas = getFirstCanvas(design);
    var designId = extractDesignId(design);

    var candidates = [
      normalizeImage(firstCanvas ? firstCanvas.imageUrl : ""),
      normalizeImage(firstCanvas ? firstCanvas.svgUrl : ""),
      normalizeImage(design.previewImageUrl),
      designId
        ? "https://cdn.inksoft.com/images/publishers/2959/designs/" +
          designId +
          ".front.480.png"
        : "",
      normalizeImage(firstCanvas ? firstCanvas.thumbnailUrl : ""),
      normalizeImage(design.thumbnailUrl),
      normalizeImage(design.imageUrl)
    ].filter(Boolean);

    return Array.from(new Set(candidates));
  }

  function uniqueValues(items, field) {
    var values = items
      .map(function (item) {
        return item[field];
      })
      .filter(Boolean);

    return Array.from(new Set(values)).sort(function (a, b) {
      return String(a).localeCompare(String(b));
    });
  }

  function resetSelect(select, label) {
    if (!select) return;

    select.innerHTML =
      '<option value="">' + escapeHtml(label) + "</option>";
  }

  function populateFilters() {
    resetSelect(els.segment, "All Segments");
    resetSelect(els.productGroup, "All Product Groups");
    resetSelect(els.collection, "All Collections");

    [
      [els.segment, "segment"],
      [els.productGroup, "productGroup"],
      [els.collection, "collection"]
    ].forEach(function (entry) {
      var select = entry[0];
      var field = entry[1];

      uniqueValues(allDesigns, field).forEach(function (value) {
        var option = document.createElement("option");
        option.value = value;
        option.textContent = value;
        select.appendChild(option);
      });
    });
  }

  function buildCard(design) {
    var designId = extractDesignId(design);
    var image = getBestImage(design);
    var fallbackImages = getFallbackImages(design);

    var imageHtml = image
      ? '<img class="dc-card-image" src="' +
        escapeHtml(image) +
        '" alt="' +
        escapeHtml(design.title || "") +
        '" loading="lazy" decoding="async" data-fallback-images="' +
        escapeHtml(JSON.stringify(fallbackImages)) +
        '" data-fallback-index="0">'
      : '<div class="dc-image-placeholder">No preview available</div>';

    return (
      '<article class="dc-card">' +
      '<div class="dc-card-image-wrap">' +
      imageHtml +
      "</div>" +
      '<div class="dc-card-body">' +
      '<div class="dc-card-title">' +
      escapeHtml(design.title || "Untitled") +
      "</div>" +
      '<div class="dc-card-tags">' +
      (design.segment
        ? '<span class="dc-tag">' + escapeHtml(design.segment) + "</span>"
        : "") +
      (design.productGroup
        ? '<span class="dc-tag">' +
          escapeHtml(design.productGroup) +
          "</span>"
        : "") +
      "</div>" +
      '<div class="dc-meta">' +
      '<div class="dc-meta-label">Design ID</div>' +
      '<div class="dc-meta-value">' +
      escapeHtml(designId) +
      "</div>" +
      '<div class="dc-meta-label">InkSoft ID</div>' +
      '<div class="dc-meta-value">' +
      escapeHtml(design.inksoftDesignId || "") +
      "</div>" +
      '<div class="dc-meta-label">Slug</div>' +
      '<div class="dc-meta-value">' +
      escapeHtml(design.slug || "") +
      "</div>" +
      '<div class="dc-meta-label">Collection</div>' +
      '<div class="dc-meta-value">' +
      escapeHtml(design.collection || "") +
      "</div>" +
      '<div class="dc-meta-label">Segment</div>' +
      '<div class="dc-meta-value">' +
      escapeHtml(design.segment || "") +
      "</div>" +
      '<div class="dc-meta-label">Product Group</div>' +
      '<div class="dc-meta-value">' +
      escapeHtml(design.productGroup || "") +
      "</div>" +
      '<div class="dc-meta-label">Theme</div>' +
      '<div class="dc-meta-value">' +
      escapeHtml(design.theme || "") +
      "</div>" +
      '<div class="dc-meta-label">School Code</div>' +
      '<div class="dc-meta-value">' +
      escapeHtml(design.schoolCode || "") +
      "</div>" +
      "</div>" +
      '<div class="dc-actions">' +
      '<button type="button" class="dc-btn dc-btn-primary" data-copy-id="' +
      escapeHtml(designId) +
      '">Copy Design ID</button>' +
      '<button type="button" class="dc-btn dc-btn-secondary" data-copy-slug="' +
      escapeHtml(design.slug || "") +
      '">Copy Slug</button>' +
      "</div>" +
      "</div>" +
      "</article>"
    );
  }

  function getFilteredDesigns() {
    var search = String(els.search ? els.search.value : "")
      .trim()
      .toLowerCase();

    var segment = els.segment ? els.segment.value : "";
    var productGroup = els.productGroup ? els.productGroup.value : "";
    var collection = els.collection ? els.collection.value : "";

    return allDesigns.filter(function (design) {
      var haystack = [
        design.title,
        design.slug,
        design.segment,
        design.productGroup,
        design.collection,
        design.theme,
        design.schoolCode,
        design.sourceCategoryName,
        design.sourceCategoryPath,
        extractDesignId(design)
      ]
        .join(" ")
        .toLowerCase();

      if (search && haystack.indexOf(search) === -1) return false;
      if (segment && design.segment !== segment) return false;
      if (productGroup && design.productGroup !== productGroup) return false;
      if (collection && design.collection !== collection) return false;

      return true;
    });
  }

  function ensurePaginationContainer() {
    var pagination = document.getElementById("dc-pagination");

    if (pagination) {
      return pagination;
    }

    pagination = document.createElement("div");
    pagination.id = "dc-pagination";
    pagination.className = "dc-pagination";

    if (els.grid) {
      els.grid.insertAdjacentElement("afterend", pagination);
    }

    return pagination;
  }

  function setUrlPage(page) {
    var url = new URL(window.location.href);

    if (page <= 1) {
      url.searchParams.delete("page");
    } else {
      url.searchParams.set("page", String(page));
    }

    window.history.replaceState({}, "", url.toString());
  }

  function getPageNumbers(current, total) {
    if (total <= 7) {
      return Array.from({ length: total }, function (_unused, index) {
        return index + 1;
      });
    }

    var pages = [1];
    var start = Math.max(2, current - 1);
    var end = Math.min(total - 1, current + 1);

    if (start > 2) pages.push("ellipsis-start");

    for (var page = start; page <= end; page += 1) {
      pages.push(page);
    }

    if (end < total - 1) pages.push("ellipsis-end");

    pages.push(total);
    return pages;
  }

  function renderPagination(totalItems) {
    var pagination = ensurePaginationContainer();
    var totalPages = Math.max(1, Math.ceil(totalItems / PAGE_SIZE));

    if (totalItems <= PAGE_SIZE) {
      pagination.innerHTML = "";
      pagination.hidden = true;
      return;
    }

    pagination.hidden = false;

    var numberButtons = getPageNumbers(currentPage, totalPages)
      .map(function (page) {
        if (typeof page !== "number") {
          return (
            '<span class="dc-pagination-ellipsis" aria-hidden="true">…</span>'
          );
        }

        var active = page === currentPage;

        return (
          '<button type="button" class="dc-page-btn' +
          (active ? " is-active" : "") +
          '" data-page="' +
          page +
          '"' +
          (active ? ' aria-current="page"' : "") +
          ">" +
          page +
          "</button>"
        );
      })
      .join("");

    pagination.innerHTML =
      '<button type="button" class="dc-page-btn dc-page-btn--nav" data-page-action="previous"' +
      (currentPage <= 1 ? " disabled" : "") +
      ">Previous</button>" +
      '<div class="dc-page-numbers">' +
      numberButtons +
      "</div>" +
      '<button type="button" class="dc-page-btn dc-page-btn--nav" data-page-action="next"' +
      (currentPage >= totalPages ? " disabled" : "") +
      ">Next</button>";
  }

  function render() {
    var designs = getFilteredDesigns();
    var totalItems = designs.length;
    var totalPages = Math.max(1, Math.ceil(totalItems / PAGE_SIZE));

    if (currentPage > totalPages) currentPage = totalPages;
    if (currentPage < 1) currentPage = 1;

    var startIndex = (currentPage - 1) * PAGE_SIZE;
    var endIndex = Math.min(startIndex + PAGE_SIZE, totalItems);
    var pageDesigns = designs.slice(startIndex, endIndex);

    if (els.summary) {
      els.summary.textContent = totalItems
        ? "Showing " +
          (startIndex + 1) +
          "–" +
          endIndex +
          " of " +
          totalItems +
          " designs"
        : "0 designs found";
    }

    if (!totalItems) {
      els.grid.innerHTML =
        '<div class="dc-empty">No designs found.</div>';

      renderPagination(0);
      setUrlPage(1);
      return;
    }

    els.grid.innerHTML = pageDesigns.map(buildCard).join("");
    renderPagination(totalItems);
    setUrlPage(currentPage);
  }

  function resetToFirstPageAndRender() {
    currentPage = 1;
    render();
  }

  function goToPage(page) {
    var designs = getFilteredDesigns();
    var totalPages = Math.max(1, Math.ceil(designs.length / PAGE_SIZE));
    var nextPage = Math.min(Math.max(Number(page) || 1, 1), totalPages);

    if (nextPage === currentPage) return;

    currentPage = nextPage;
    render();

    if (els.root) {
      els.root.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
    }
  }

  async function copyText(value, button, originalLabel) {
    try {
      await navigator.clipboard.writeText(value || "");
      button.textContent = "Copied!";

      window.setTimeout(function () {
        button.textContent = originalLabel;
      }, 1500);
    } catch (error) {
      console.error("Clipboard error:", error);
      button.textContent = "Copy failed";

      window.setTimeout(function () {
        button.textContent = originalLabel;
      }, 1500);
    }
  }

  function addQueryParam(url, key, value) {
    try {
      var parsed = new URL(url, window.location.href);
      parsed.searchParams.set(key, value);
      return parsed.toString();
    } catch (_error) {
      var joiner = String(url).indexOf("?") >= 0 ? "&" : "?";
      return String(url) + joiner + encodeURIComponent(key) + "=" + encodeURIComponent(value);
    }
  }

  function extractRecordsFromPayload(result) {
    if (!result) return [];
    if (Array.isArray(result)) return result;

    if (Array.isArray(result.records)) return result.records;
    if (Array.isArray(result.designs)) return result.designs;
    if (Array.isArray(result.items)) return result.items;
    if (Array.isArray(result.results)) return result.results;

    if (result.data) {
      if (Array.isArray(result.data)) return result.data;
      if (Array.isArray(result.data.records)) return result.data.records;
      if (Array.isArray(result.data.designs)) return result.data.designs;
      if (Array.isArray(result.data.items)) return result.data.items;
      if (Array.isArray(result.data.results)) return result.data.results;
      if (Array.isArray(result.data.trending)) return result.data.trending;
      if (Array.isArray(result.data.featuredPE)) return result.data.featuredPE;
      if (Array.isArray(result.data.featuredSpiritWear)) return result.data.featuredSpiritWear;
    }

    return [];
  }

  function getDesignApiCandidates() {
    var configured = String(API_BASE || "").replace(/\/+$/, "");

    var candidates = [
      "/apps/inksoft/design-inspiration/designs?take=500",
      "/apps/inksoft/design-inspiration/designs?take=250",
      configured ? configured + "/designs?take=500" : "",
      configured ? configured + "/designs?take=250" : "",
      "https://shopify-inksoft-poc-node.azurewebsites.net/api/poc/design-inspiration/designs?take=500",
      "https://shopify-inksoft-poc-node.azurewebsites.net/api/poc/design-inspiration/designs?take=250"
    ].filter(Boolean);

    return Array.from(new Set(candidates));
  }

  async function loadDesigns() {
    setStatus("Loading design catalog...", "info");

    var candidates = getDesignApiCandidates();
    var lastError = null;
    var loadedFrom = "";
    var records = [];

    for (var i = 0; i < candidates.length; i += 1) {
      var url = addQueryParam(candidates[i], "_dc", String(Date.now()));

      try {
        var result = await fetchJson(url);
        var candidateRecords = extractRecordsFromPayload(result);

        console.log("[Design Catalog] API:", url);
        console.log("[Design Catalog] Records:", candidateRecords.length);
        console.log("[Design Catalog] Sample:", candidateRecords[0]);

        if (candidateRecords.length) {
          records = candidateRecords;
          loadedFrom = url;
          break;
        }
      } catch (error) {
        lastError = error;
        console.warn("[Design Catalog] Could not load:", url, error);
      }
    }

    allDesigns = Array.isArray(records) ? records : [];

    populateFilters();
    render();

    if (allDesigns.length) {
      setStatus(allDesigns.length + " designs loaded.", "success");
      console.log("[Design Catalog] Loaded from:", loadedFrom);
      return;
    }

    if (lastError) {
      throw lastError;
    }

    setStatus("0 designs loaded. No records were returned by the design API candidates.", "info");
  }

  function bindEvents() {
    if (els.search) {
      els.search.addEventListener("input", resetToFirstPageAndRender);
    }

    [els.segment, els.productGroup, els.collection]
      .filter(Boolean)
      .forEach(function (element) {
        element.addEventListener("change", resetToFirstPageAndRender);
      });

    document.addEventListener("click", async function (event) {
      var target = event.target;

      if (!(target instanceof Element)) return;

      var copyId = target.closest("[data-copy-id]");

      if (copyId) {
        await copyText(
          copyId.getAttribute("data-copy-id") || "",
          copyId,
          "Copy Design ID"
        );
        return;
      }

      var copySlug = target.closest("[data-copy-slug]");

      if (copySlug) {
        await copyText(
          copySlug.getAttribute("data-copy-slug") || "",
          copySlug,
          "Copy Slug"
        );
        return;
      }

      var pageButton = target.closest("[data-page]");

      if (pageButton) {
        goToPage(Number(pageButton.getAttribute("data-page")));
        return;
      }

      var pageAction = target.closest("[data-page-action]");

      if (pageAction) {
        var action = pageAction.getAttribute("data-page-action");

        if (action === "previous") goToPage(currentPage - 1);
        if (action === "next") goToPage(currentPage + 1);
      }
    });

    document.addEventListener(
      "error",
      function (event) {
        var image = event.target;

        if (!(image instanceof HTMLImageElement)) return;
        if (!image.classList.contains("dc-card-image")) return;

        var fallbackImages = [];

        try {
          fallbackImages = JSON.parse(
            image.getAttribute("data-fallback-images") || "[]"
          );
        } catch (_error) {
          fallbackImages = [];
        }

        var currentIndex = Number(
          image.getAttribute("data-fallback-index") || "0"
        );

        var currentSrc = image.src;
        var nextSrc = "";

        while (currentIndex < fallbackImages.length) {
          var candidate = fallbackImages[currentIndex];
          currentIndex += 1;

          if (candidate && candidate !== currentSrc) {
            nextSrc = candidate;
            break;
          }
        }

        image.setAttribute("data-fallback-index", String(currentIndex));

        if (nextSrc) {
          image.src = nextSrc;
          return;
        }

        image.style.display = "none";

        var wrap = image.closest(".dc-card-image-wrap");

        if (wrap && !wrap.querySelector(".dc-image-placeholder")) {
          wrap.insertAdjacentHTML(
            "beforeend",
            '<div class="dc-image-placeholder">Preview unavailable</div>'
          );
        }
      },
      true
    );

    window.addEventListener("popstate", function () {
      currentPage = getInitialPage();
      render();
    });
  }

  async function init() {
    try {
      if (!els.grid || !els.summary) {
        throw new Error("Design Catalog containers were not found.");
      }

      bindEvents();
      ensurePaginationContainer();
      await loadDesigns();
    } catch (error) {
      console.error(error);

      setStatus(
        "Unable to load the Design Catalog. Check the Azure endpoint and browser console.",
        "error"
      );
    }
  }

  init();
})();